import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import matcher from '../../core/matcher'
import {replace} from '../../core/extract'
import {escapeRegExp} from '../../core/regexpz'
import phonez from '../../core/phonez'
import Picker from '../../core/components/Picker'
import {DEFAULT_CONTACT_QUERY, queryMinorContactStream} from '../actions'
import i18n from '../i18n'

function getIds(array) {
    array = ((array instanceof Array) && array) || (array && [array] || [])

    return array.map((v) => v.uid || v)
}

function contactMatcher(source) {
    return (query, cb) => {
        var matches

        if (query && (query.name || query.contacts)) {
            const firstNameRegexp = query.name && query.name.firstName && new RegExp(escapeRegExp(query.name.firstName), 'i')
            const lastNameRegexp = query.name && query.name.lastName && new RegExp(escapeRegExp(query.name.lastName), 'i')
            const phoneRegexp = query.contacts && query.contacts.phone && new RegExp(escapeRegExp(phonez(query.contacts.phone).toNational()), 'i')
            const mailRegexp = query.contacts && query.contacts.mail && new RegExp(escapeRegExp(query.contacts.mail), 'i')
            const faxRegexp = query.contacts && query.contacts.fax && new RegExp(escapeRegExp(phonez(query.contacts.fax).toNational()), 'i')

            matches = source.filter((contact) => {
                var match = true
                match = match && (!firstNameRegexp || firstNameRegexp.test(contact.name.firstName || contact.name.value))
                match = match && (!lastNameRegexp || lastNameRegexp.test(contact.name.lastName || contact.name.value))
                match = match && (!phoneRegexp || !!contact.contacts.find((c) => c.phone && phoneRegexp.test(c.phone)))
                match = match && (!mailRegexp || !!contact.contacts.find((c) => c.mail && mailRegexp.test(c.mail)))
                match = match && (!faxRegexp || !!contact.contacts.find((c) => c.fax && faxRegexp.test(c.fax)))
                return match
            })
        } else {
            matches = source
        }

        cb(matches)
    }

    return matcher({
        source: stream,
        identify: (c) => c.name.firstName + ' ' + c.name.lastName
    })
}

class TypeaheadContactPicker extends Component {
    static propTypes = {
        patrimonies: PropTypes.any,
        query: PropTypes.object
    }

    constructor(props) {
        super(props)

        this.state = {
            source: () => null,
            matches: []
        }
    }

    componentWillMount() {
        const {dispatch, patrimonies} = this.props

        dispatch(queryMinorContactStream({...DEFAULT_CONTACT_QUERY, patrimonyUids: getIds(patrimonies), range: {offset: 0, limit: 999}}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.patrimonies != this.props.patrimonies) {
            const {dispatch, patrimonies} = nextProps

            dispatch(queryMinorContactStream({...DEFAULT_CONTACT_QUERY, patrimonyUids: getIds(patrimonies), range: {offset: 0, limit: 999}}))
        }
        if (nextProps.stream != this.props.stream) {
            const {stream, query} = nextProps

            const source = contactMatcher(stream)
            source(query, (matches) => {
                this.setState({source, matches})
            })
        }
        if (nextProps.query != this.props.query) {
            const {query} = nextProps
            const {source} = this.state

            source(query, (matches) => {
                this.setState({matches})
            })
        }
    }

    render() {
        const {dispatch, stream, range, query, ...others} = this.props
        const {matches} = this.state

        const afterContacts = () => {
            if (range && (range.limit < range.count - 1)) {
                const count = range.limit + 1
                return (
                    <p>{replace(i18n.useSearchContactFilters, {count})}</p>
                )
            }
        }

        const displayContact = (contact, mode) => {
            const phoneMedium = contact.contacts.find((c) => c.contactInfoType == 'Phone')

            if (mode == 'Picked') {
                return (
                    <h4>
                        <span>{contact.name.firstName}</span>
                        <span> {contact.name.lastName}</span>
                        <span>{contact.name.value}</span>
                        {phoneMedium && (
                            <span> ({phonez(phoneMedium.phone).format()})</span>
                        )}
                    </h4>
                )
            }

            return (
                <span>
                    <span>{contact.name.firstName}</span>
                    <span> {contact.name.lastName}</span>
                    <span>{contact.name.value}</span>
                    {phoneMedium && (
                        <span> ({phonez(phoneMedium.phone).format()})</span>
                    )}
                </span>
            )
        }

        return (
            <div>
                <Picker
                    source={matches}
                    identify={(c) => c.uid}
                    display={displayContact}
                    after={afterContacts()}
                    {...others}>
                </Picker>
            </div>
        )
    }
}

TypeaheadContactPicker = connect((state) => ({
    stream: state.patrimony.contact.minorStream,
    range: state.patrimony.contact.minorRange
}))(TypeaheadContactPicker)

export default TypeaheadContactPicker


// WEBPACK FOOTER //
// ./lib/patrimony/components/TypeaheadContactPicker.js